import { render, staticRenderFns } from "./my-sign-list.vue?vue&type=template&id=56694688&scoped=true&"
import script from "./my-sign-list.vue?vue&type=script&lang=js&"
export * from "./my-sign-list.vue?vue&type=script&lang=js&"
import style0 from "./my-sign-list.vue?vue&type=style&index=0&id=56694688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56694688",
  null
  
)

export default component.exports